"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.object.values");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _todo = _interopRequireDefault(require("./_todo.vue"));
var _deviceType = _interopRequireDefault(require("./_deviceType.vue"));
var _pieChart = _interopRequireDefault(require("./_pieChart.vue"));
var _panelGroup = _interopRequireDefault(require("./_panelGroup.vue"));
var _map = _interopRequireDefault(require("@/components/map"));
var _collapseTransition = _interopRequireDefault(require("@/utils/collapse-transition"));
var _auth = require("@/utils/auth");
var _adminOperationReport = require("@/utils/adminOperationReport");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 数据统计模块
// 订单统计模块
// 数据总览模块
// 地图
// 折叠动画
var _default = exports.default = {
  name: 'Home',
  components: {
    panelGroup: _panelGroup.default,
    pieChart: _pieChart.default,
    deviceType: _deviceType.default,
    maps: _map.default,
    todo: _todo.default,
    collapseTransition: _collapseTransition.default
  },
  data: function data() {
    return {
      date_type: 1,
      totalData: {},
      statMoney: {},
      deviceData: {},
      shopInfo: {},
      mapScreen: false,
      mapDataStatus: false,
      search_agent_id: 0,
      platList: [],
      brand_icon: {},
      percent: {
        0: 'bao',
        4: 'wash',
        2: 'massage',
        3: 'zhuang'
      },
      device_type: -1,
      informStatus: false,
      isShow: false,
      informList: [],
      // 添加用于存储随机点位的数组
      randomMarkers: [],
      // 操作日志提示相关
      operationLogStatus: false,
      operationLogList: []
    };
  },
  computed: {
    device: function device() {
      return this.$store.state.app.device;
    },
    deviceNameObj: function deviceNameObj() {
      return this.$store.getters.deviceNameObj;
    },
    agentInfo: function agentInfo() {
      return this.$store.getters.agentInfo;
    },
    rests: function rests() {
      return this.$store.getters.rests;
    }
  },
  created: function created() {
    if (!this.checkRoles(['terminal']) && !this.checkRoles(['merchants']) && !this.rests.informClose) this.getInform();
  },
  mounted: function mounted() {
    // 发起网络请求
    this.getMoney();
    this.getPlatList();
    this.checkHid();
    this.getOperationLogNotify();
  },
  methods: {
    checkHid: function checkHid() {
      var service = (0, _auth.getPermission)('server_permission_menus');
      // console.log(service.menus)
      if (service.includes('homeIndex') || service.includes('home')) {
        this.isShow = true;
      }
    },
    /**
     * 可提现金额
     */
    getMoney: function getMoney() {
      var _this = this;
      return this.$get('agentapi/index').then(function (res) {
        _this.statMoney = res;
      });
    },
    /**
     * 服务通知
     */
    getInform: function getInform() {
      var _this2 = this;
      this.$get('agentapi/business/pending_items_bubble').then(function (res) {
        var informStatus = false;
        for (var _i = 0, _Object$values = Object.values(res); _i < _Object$values.length; _i++) {
          var item = _Object$values[_i];
          if (item.num > 0) {
            if (!informStatus) {
              informStatus = true;
            }
            var info = item.info;
            if (item.key == 'user_complaints') {
              item.content = "".concat(info.title, " ").concat(info.date);
            } else if (item.key == 'user_feedback') {
              item.content = "".concat(info.user_name, " ").concat(info.user_mobile, " ").concat(info.title);
            } else if (item.key == 'user_refund_apply') {
              item.content = "".concat(info.title, " ").concat(info.apply_mobile, " ").concat(info.store_name, " ").concat(info.date);
            } else if (item.key == 'agent_withdraw_apply') {
              item.content = "".concat(info.applier_user_name, " ").concat(info.applier_user_phone, " ").concat(info.date);
            } else if (item.key == 'merchant_withdraw_apply') {
              item.content = "".concat(info.applier_user_name, " ").concat(info.applier_user_phone, " ").concat(info.date);
            } else if (item.key == 'user_withdraw_apply') {
              item.content = "".concat(info.user_nick_name, " ").concat(info.user_mobile, " ").concat(info.date);
            }
          }
        }
        _this2.informStatus = informStatus;
        _this2.informList = res;
      });
    },
    /**
     * 地图数据
     */
    getDeviceData: function getDeviceData() {
      var _this3 = this;
      this.$get('agentapi/my_total_device_data', {
        search_agent_id: this.search_agent_id,
        device_type: this.device_type
      }).then(function (res) {
        // const store_list = []
        res.store_list.map(function (item) {
          if (item.id) {
            var device_type = 0;
            for (var i in item.device_type_arr) {
              if (item.device_type_arr[i].has_num > 0) {
                device_type = item.device_type_arr[i].depend_type;
                break;
              }
            }
            if (_this3.brand_icon[item.belong_agent_id][device_type]) {
              item.icon = _this3.brand_icon[item.belong_agent_id][device_type];
              // store_list.push(item)
            }
          }
        });
        _this3.deviceData = res;
        _this3.store_list = res.store_list;
        // 只有当有实际数据时才更新地图标记，避免清空随机生成的标记
        if (res.store_list.length > 0 && _this3.$refs.map_box) {
          _this3.$refs.map_box.setMapLayer(res.store_list);
        }
      });
    },
    /**
     * 地图标点店铺信息
     */
    setShopInfo: function setShopInfo(info) {
      if (this.mapScreen) this.mapDataStatus = !!info.id;
      this.shopInfo = info;
    },
    getPlatList: function getPlatList() {
      var _this4 = this;
      var brand_icon = {};
      this.$get('commonapi/configer/get_platform_list').then(function (res) {
        res.map(function (item) {
          brand_icon[item.agent_id] = {};
          item.device_type.map(function (icon) {
            brand_icon[item.agent_id][icon.depend_type] = icon.icon_url;
          });
        });
        _this4.brand_icon = brand_icon;
        _this4.platList = res;
        _this4.getDeviceData();
      });
    },
    /**
     * 饼图选择设备类型
     */
    pieSwitchType: function pieSwitchType(type) {
      this.$refs.pieChart.switchType(type);
      if (this.$refs.pieChart2) {
        this.$refs.pieChart2.switchType(type);
      }
      this.device_type = type;
      this.getDeviceData();
    },
    /**
     * 饼图选择平台
     */
    pieSwitchPlat: function pieSwitchPlat(search_agent_id) {
      this.$refs.pieChart.switchPlat(search_agent_id);
      if (this.$refs.pieChart2) {
        this.$refs.pieChart2.switchPlat(search_agent_id);
      }
      this.search_agent_id = search_agent_id;
      this.getDeviceData();
    },
    setMapScreen: function setMapScreen() {
      var _this5 = this;
      this.mapScreen = true;
      setTimeout(function () {
        _this5.$refs.map_box_screen.setMapLayer(_this5.store_list);
      }, 20);
    },
    /**
     * 获取待提示的操作日志
     */
    getOperationLogNotify: function getOperationLogNotify() {
      var _this6 = this;
      var token = this.$store.getters.token;
      var userId = this.$store.getters.userId || '';
      var agentId = this.$store.getters.agentId || '';
      if (!token) return;
      this.$get('agentapi/admin_operation/list', {
        notify: 0
      }).then(function (res) {
        if (res && res.list && res.list.length > 0) {
          _this6.operationLogList = res.list;
          _this6.operationLogStatus = true;

          // 面板显示后，立即批量标记为已通知
          var ids = res.list.map(function (item) {
            return item.id;
          });
          (0, _adminOperationReport.batchMarkOperationNotified)(ids);
        }
      }).catch(function (err) {
        console.log('[操作日志提示] 获取失败', err);
      });
    },
    /**
     * 关闭操作日志提示并批量标记为已通知
     */
    closeOperationLogNotify: function closeOperationLogNotify() {
      this.operationLogStatus = false;

      // 调用封装好的批量标记函数
      if (this.operationLogList && this.operationLogList.length > 0) {
        var ids = this.operationLogList.map(function (item) {
          return item.id;
        });
        (0, _adminOperationReport.batchMarkOperationNotified)(ids);
      }
    },
    /**
     * 跳转到平台操作日志页面
     */
    goToOperationLogPage: function goToOperationLogPage() {
      this.operationLogStatus = false;

      // 先批量标记为已通知
      if (this.operationLogList && this.operationLogList.length > 0) {
        var ids = this.operationLogList.map(function (item) {
          return item.id;
        });
        (0, _adminOperationReport.batchMarkOperationNotified)(ids);
      }

      // 跳转到操作日志页面
      this.$router.push({
        path: '/run/operationLog'
      });
    }
  }
};